module.exports = __webpack_public_path__ + "static/media/i8a.aab69c5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i8a.svg
// module id = 400
// module chunks = 12